import {
  DoryStreamingHeader,
  DoryStreamingMessage,
  DoryMessageType,
  DoryServiceType,
} from '../../abstract/StreamingMessages';

function getQuoteHeader(messageType: DoryMessageType): DoryStreamingHeader {
  return {
    service: DoryServiceType.QUOTE,
    version: 'v1',
    messageType,
  };
}

type QuoteSubscribePayload = {
  rics: string[];
  fids: string[];
};
type QuoteUnsubscribePayload = {
  rics: string[];
};

type QuoteResponsePayloadRaw = {
  ric: string;
  fids: string[];
  values: string[];
};
type QuoteResponsePayload = {
  ric: string;
  data: {
    [fid: string]: string;
  };
};

export {
  QuoteResponsePayloadRaw,
  QuoteResponsePayload,
  QuoteSubscribePayload as QuoteRequestPayload,
  getQuoteHeader,
};

//#region Subscribe
type QuoteSubscribeHeader = {
  messageId?: string;
} & DoryStreamingHeader;

type QuoteSubscribeRequest = {
  header: QuoteSubscribeHeader;
  payload: QuoteSubscribePayload[];
} & DoryStreamingMessage;

type QuoteSubscribeResponse = {
  header: QuoteSubscribeHeader;
  payload: {
    status: number;
    message: string;
    subscription: {
      realtime: string[];
      delayed: string[];
      failed: string[];
    };
    fids?: string[];
  };
} & DoryStreamingMessage;

function getQuoteSubscribeRequest(
  messageId: string,
  payload: QuoteSubscribePayload[]
): QuoteSubscribeRequest {
  return {
    header: {
      ...getQuoteHeader(DoryMessageType.SUBSCRIBE),
      messageId,
    },
    payload,
  };
}

export {
  QuoteSubscribeHeader,
  QuoteSubscribeRequest,
  QuoteSubscribeResponse,
  getQuoteSubscribeRequest,
};
//#endregion

//#region Snapshot
type QuoteSnapshotHeader = {
  messageId?: string;
} & DoryStreamingHeader;
type QuoteSnapshotResponseRaw = {
  header: QuoteSnapshotHeader;
  payload: QuoteResponsePayloadRaw[];
} & DoryStreamingMessage;
type QuoteSnapshotResponse = {
  header: QuoteSnapshotHeader;
  payload: QuoteResponsePayload[];
} & DoryStreamingMessage;

export { QuoteSnapshotHeader, QuoteSnapshotResponse, QuoteSnapshotResponseRaw };
//#endregion

//#region Update
type QuoteUpdateResponseRaw = {
  header: DoryStreamingHeader;
  payload: QuoteResponsePayloadRaw[];
} & DoryStreamingMessage;
type QuoteUpdateResponse = {
  header: DoryStreamingHeader;
  payload: QuoteResponsePayload[];
} & DoryStreamingMessage;

export { QuoteUpdateResponse, QuoteUpdateResponseRaw };
//#endregion

//#region Unsubscribe
type QuoteUnsubscribeRequest = {
  header: DoryStreamingHeader;
  payload: QuoteUnsubscribePayload[];
} & DoryStreamingMessage;

type QuoteUnsubscribeResponse = {
  header: DoryStreamingHeader;
  payload: {
    status: number;
    message: string;
  };
} & DoryStreamingMessage;

export { QuoteUnsubscribeRequest, QuoteUnsubscribeResponse };
//#endregion
